import React from "react";

export const Home = React.lazy(() => import("./Home"));
export const Login = React.lazy(() => import("./Login"));
export const NewTask = React.lazy(() => import("./NewTask"));
export const Comments = React.lazy(() => import("./Comments"));
export const Profile = React.lazy(() => import("./Profile"));
export const TaskList = React.lazy(() => import("./TaskList"));
export const ViewFile = React.lazy(() => import("./ViewFile"));
